<ion-app>
  <ngx-spinner size="medium" type="ball-clip-rotate">
    <p style="font-size: 20px; color: white">{{spinMsg}}</p>
  </ngx-spinner>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
